import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Navigate } from "react-router-dom";
import { loginSuccess } from "@/features/auth/duck/auth"; // Import your action

const AuthGuard = ({ children }) => {
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.auth.isLogin, shallowEqual);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const uuid = localStorage.getItem("userId");

    if (token && isLogin && uuid) {
      dispatch(loginSuccess({ token, uuid }));
    }
  }, [dispatch, isLogin]);

  if (!isLogin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthGuard;
